module.exports = __webpack_public_path__ + "img/shield.ee47fa6.svg";